export { default as PromoBlock } from "./PromoBlock";
